module.exports = __webpack_public_path__ + "img/con1_txt.218000b7.png";